import { X } from "lucide-react";

const HEADER_COLORS = {
  indigo: { bar: "bg-blue-500", icon: "bg-blue-50 text-blue-600" },
  emerald: { bar: "bg-emerald-500", icon: "bg-emerald-50 text-emerald-600" },
  blue: { bar: "bg-blue-500", icon: "bg-blue-50 text-blue-600" },
  rose: { bar: "bg-rose-500", icon: "bg-rose-50 text-rose-600" },
  amber: { bar: "bg-amber-500", icon: "bg-amber-50 text-amber-600" },
};

export function Modal({ title, onClose, children, accent = "indigo" }) {
  const tone = HEADER_COLORS[accent] || HEADER_COLORS.indigo;
  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/45 backdrop-blur-sm" onClick={onClose} />
      <div
        className="relative z-10 w-full max-w-md overflow-hidden rounded-[var(--hx-radius)] bg-[var(--hx-surface)]"
        style={{ border: "1px solid var(--hx-border)", boxShadow: "var(--hx-shadow-lift)" }}
      >
        <span className={`absolute inset-x-0 top-0 h-1 ${tone.bar}`} />
        <div className="flex items-center justify-between gap-3 border-b px-6 py-4" style={{ borderColor: "var(--hx-border)" }}>
          <h3 className="font-display font-semibold text-base text-[var(--hx-text)]">{title}</h3>
          <button
            onClick={onClose}
            className="flex h-7 w-7 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600"
          >
            <X size={14} />
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
